import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SnCurrentUser } from '@lib/auth';
import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'sn-confirm-livestream-devices-dialog',
  templateUrl: './confirm-livestream-devices-dialog.component.html',
  styleUrls: ['./confirm-livestream-devices-dialog.component.scss'],
})
export class ConfirmLivestreamDevicesDialogComponent implements OnInit, OnDestroy {
  public form = new UntypedFormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'confirmDeviceLivestream',
      type: 'checkbox',
      templateOptions: {
        label: t('map.livestream.confirmDialog.doNotAskMeAgain'),
      },
    },
  ];
  public isLoading: boolean = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public action: string,
    private readonly _currentUser: SnCurrentUser,
    private readonly _toastrService: ToastrService,
    private readonly _dialogRef: MatDialogRef<ConfirmLivestreamDevicesDialogComponent>,
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public proceed(): void {
    if (this.formModel.confirmDeviceLivestream) {
      this.isLoading = true;
      this._currentUser
        .updateSettings({
          mapSetting: {
            ...this._currentUser.settings.mapSetting,
            [this.action]: true,
          },
        })
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: () => {
            this.isLoading = false;
            this._dialogRef.close(true);
          },
          error: () => {
            this.isLoading = false;
            this._toastrService.error('Unable to save setting. Please try again later.');
            this._dialogRef.close(true);
          },
        });
    } else {
      this._dialogRef.close(true);
    }
  }
}
